import { action } from '@ember/object';
import Component from '@glimmer/component';
import GeneralTablesCellsCellEditable from 'lumen/components/general/tables/cells/cell-editable';
import type { Room } from 'lumen/components/settings/central-mapping/roomtype-mapping';

interface SettingsCentralMappingRoomtypeMappingCellHeaderRoomtypeSignature {
  Args: {
    canEdit: boolean;
    onSaveRoomtypeName: (roomtype: Room, newName: string) => void;
    roomtype: Room;
  };
}

export default class SettingsCentralMappingRoomtypeMappingCellHeaderRoomtype extends Component<SettingsCentralMappingRoomtypeMappingCellHeaderRoomtypeSignature> {
  get hasEditRights(): boolean {
    return Boolean(this.args.roomtype.isCustom && this.args.canEdit);
  }

  @action onSaveRoomtypeName(newName: string): void {
    this.args.onSaveRoomtypeName(this.args.roomtype, newName);
  }

  <template>
    <th title={{@roomtype.proper_name}}>
      <GeneralTablesCellsCellEditable
        @displayValue={{@roomtype.proper_name}}
        @hasEditRights={{this.hasEditRights}}
        @inputValue={{@roomtype.proper_name}}
        @saveAction={{this.onSaveRoomtypeName}}
      />
    </th>
  </template>
}
